const Faq = () => {
    window.location.replace('https://heuguchon.zendesk.com/hc/ko/sections/4959345792655-%EC%9E%90%EC%A3%BC-%EB%AC%BB%EB%8A%94-%EC%A7%88%EB%AC%B8');
    return null;
};

export default Faq;
